import React, { useState } from 'react'
import { ParentLayout } from '../../../layout/parentLayout'
import NewSideBarParent from '../../../components/NewSideBarParent'
import TutorListing from '../../../components/TutorListing'
import { useNavigate } from 'react-router-dom';
import { useGetPairingQuery } from '../../../service/booking';
import moment from 'moment';

function PairingCode() {

    const navigate = useNavigate();
    // states
    const [page, setPage] = useState<number>(1);

    const {
        data: response,
        isError,
        isLoading,
        isSuccess,
    } = useGetPairingQuery({ page: page, bookingStatus: 2, limit: 12 }); // API Hook to fetch the pairing details

    // onChange handler for the page
    const onPageChange = (newPage: number) => {
        setPage(newPage);
    };

    let totalPages = Math.ceil((response?.data?.totalBooking || 12) / 12);


    return (
        <>
            <ParentLayout className="role-layout">
                <main className="content">
                    <section className="uh_spc  home_wrp">
                        <div className="conta_iner v2">
                            <div className="mn_fdx">
                                <NewSideBarParent />
                                <div className="mdl_cntnt">
                                    {isSuccess && response?.data?.booking?.length
                                        ? response?.data?.booking?.map((item, index) => (
                                            <div className='bkng_mn_code'>
                                                <h4>Your Booking Code <span>  {item?.bookingdetails?.[0]?.otp?.otp || ""}</span></h4>
                                                <div className='mn_white'>
                                                    <div className='inner'>
                                                        <figure><img src={item?.tutors?.image || `/static/images/userNew.png`} alt="" /></figure>
                                                        <div className='dtls'>
                                                            <h5>{item?.tutors?.name || ""}</h5>
                                                            <p> {moment(
                                                                item?.bookingdetails[0]?.startTime
                                                            ).format("D MMMM,YY HH:mm a")}</p>
                                                            <pre>{item?.subjects[0]?.name || ""}</pre>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))
                                        : (
                                            <div className="no_data">
                                                <figure>
                                                    <img src="/static/images/noData.png" alt="no data found" />
                                                </figure>
                                                <p>No Pairing found</p>
                                            </div>
                                        )}
                                </div>
                                <div className="sidebar_rt">
                                    <TutorListing />
                                </div>
                            </div>
                        </div>
                    </section>
                </main>
            </ParentLayout>
        </>

    )
}

export default PairingCode;